import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IWhatsappAutoTrigger } from "../whatsappAutoTriggerModel";

export const getAllWhatsappAutoTriggers = createAsyncThunk(
  "WhatsAppAutomationTrigger/FindAllWhatsAppAutomationTrigger",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WhatsAppAutomationTrigger/FindAllWhatsAppAutomationTrigger`,
        formData
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Whatsapp Auto Triggers:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createWhatsappAutoTrigger = createAsyncThunk(
  "WhatsAppAutomationTrigger/InsertWhatsAppAutomationTrigger",
  async (WhatsappAutoTriggerData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WhatsAppAutomationTrigger/InsertWhatsAppAutomationTrigger`,
        WhatsappAutoTriggerData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating whatsapp auto trigger:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateWhatsappAutoTrigger = createAsyncThunk(
  "WhatsAppAutomationTrigger/UpdateWhatsAppAutomationTrigger",
  async (WhatsappAutoTriggerData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WhatsAppAutomationTrigger/UpdateWhatsAppAutomationTrigger`,
        WhatsappAutoTriggerData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating whatsapp auto trigger :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteWhatsappAutoTrigger = createAsyncThunk(
  "WhatsAppAutomationTrigger/DeleteWhatsAppAutomationTrigger",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WhatsAppAutomationTrigger/DeleteWhatsAppAutomationTrigger`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting whatsapp auto trigger :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getWhatsappAutoTriggerByID = createAsyncThunk(
  "WhatsAppAutomationTrigger/FindByIDWhatsAppAutomationTrigger",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WhatsAppAutomationTrigger/FindByIDWhatsAppAutomationTrigger`,
        { ID: ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        TriggerName: result?.TriggerName,
        Module: result?.Module,
        Operation: result?.Operation,
        Whats_App_To: result?.Whats_App_To,
        DelayDay: result?.DelayDay,
        DelayHour: result?.DelayHour,
        DelayTime: result?.DelayTime,
        TriggerTemplateID: result?.TriggerTemplateID,
      } as IWhatsappAutoTrigger;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching whatsapp auto trigger :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const duplicateWhatsappAutoTrigger = createAsyncThunk(
  "WhatsAppAutomationTrigger/DuplicateWhatsAppAutomationTrigger",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WhatsAppAutomationTrigger/DuplicateWhatsAppAutomationTrigger`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error duplicating whatsapp auto trigger :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
